import { toast } from '@/hooks/use-toast';
import i18n from 'i18next';
import { ApiError } from './client';
export function handleApiError(error, options) {
    const { title = i18n.t('error.default'), statusMessages, fallbackMessage = i18n.t('error.unexpected'), } = options ?? {};
    let message;
    if (error instanceof ApiError) {
        message = statusMessages?.[error.status] ?? error.message;
    }
    else {
        message = fallbackMessage;
    }
    toast({
        title,
        description: message,
        variant: 'destructive',
    });
    return message;
}
